
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"8","viewBox":"0 0 11 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.223.342a.79.79 0 00-.543.24L3.975 5.285 1.902 3.213A.79.79 0 10.786 4.329l2.631 2.632a.79.79 0 001.117 0l5.263-5.263A.79.79 0 009.223.342z","fill":"#fff"}})])
          )
        }
      }
    